import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

export const fetchParameters = createAsyncThunk("parameters/fetchParameters", async () => {
    const response = await api.get(`v2/api/settings/parameters/`).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});
export const updateFileParameter = createAsyncThunk("parameters/updateFileParameter", async ({type, values}) => {
    const response = await api
        .post(`v2/api/settings/parameters/upload/${type}`, values, {
            headers: {"Content-Type": "multipart/form-data"},
        })
        .catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
    return response.data;
});
export const updateParameters = createAsyncThunk("parameters/updateParameters", async ({values}) => {
    const response = await api.put(`v2/api/settings/parameters/`, {parameters: values}).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

const initialState = {
    parameters: [],
    status: {
        type: "idle",
        error: null,
    },
};

const parametersSlice = createSlice({
    name: "parameters",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        [fetchParameters.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [fetchParameters.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.parameters = action.payload.data;
        },
        [fetchParameters.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateFileParameter.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateFileParameter.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.types = action.payload.data;
        },
        [updateFileParameter.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateParameters.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateParameters.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.parameters = action.payload.data;
        },
        [updateParameters.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
    },
});

export const {setInitialState} = parametersSlice.actions;
export default parametersSlice.reducer;

// export const loadParameter = (state, type_name) => state.parameters.parameters?.find(parameter => parameter?.type?.name === type_name)?.value
export const selectAllParameters = state => state.parameters.parameters;
export const selectAllParametersTypes = state => state.parameters.types;
